import MultipleProvisionalAgreementLinks from '@components/multipleProvisionalAgreementLinks';
import ProvisionalAgreementLink from '@components/provisionalAgreementLink';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import { ORDER_SUMMARY } from '@/constants/orderSummary';
import ShoppingCart from '@/components/shoppingCart';
import LegalTerms from '@/components/legalTerms';
import Spinner from '@/components/spinner';
import Title from '@/components/title/index';
import Button, {
  BUTTON_TYPE,
  BUTTON_WIDTH,
  BUTTON_TYPE_HTML,
  BUTTON_OPERATION,
} from '@/bit/components/components.button';

function OrderSummary({
  className,
  control,
  shoppingCart,
  loadingShoppingCart,
  loadingButtonShoppingCart,
  nextStepsText,
  buttonCustomError = '',
}) {
  const {
    legalTerms,
    isTaxChanged,
    taxShortName,
    recurringPrices,
    oneTimePrices,
    totalOneTimePrice,
    totalRecurringPrice,
    contractSummaryUrl,
    contractSummaries,
    updateNote,
  } = { ...shoppingCart };

  return (
    <div
      className={` ${className} order-summary-container`}
      data-cy={ORDER_SUMMARY.ID}
    >
      {loadingShoppingCart && <Spinner />}
      {shoppingCart && (
        <div
          className={`order-summary-container__shopping-cart ${
            loadingShoppingCart
              ? 'order-summary-container__shopping-cart--opacity'
              : ''
          }`}
        >
          <Title
            text={ORDER_SUMMARY.TITLE}
            cyData={`${ORDER_SUMMARY.ID}-title`}
          />
          <ShoppingCart
            recurringPrices={recurringPrices}
            oneTimePrices={oneTimePrices}
            totalOneTimePrice={totalOneTimePrice}
            totalRecurringPrice={totalRecurringPrice}
            taxShortName={taxShortName}
            isTaxChanged={isTaxChanged}
          />
          {updateNote && (
            <Text
              className="updateNote"
              text={updateNote}
              color={TEXT_COLOR.GREY5}
              size={TEXT_SIZE.CAPTION2}
              cyData="update-note"
            />
          )}
          {contractSummaryUrl && (
            <ProvisionalAgreementLink
              urlDocument={contractSummaryUrl}
              className="order-summary__link"
              cyData={`${ORDER_SUMMARY.ID}__link`}
            />
          )}
          {Array.isArray(contractSummaries) && (
            <MultipleProvisionalAgreementLinks
              urlDocuments={contractSummaries}
              className="order-summary__link"
              cyData={`${ORDER_SUMMARY.ID}__link`}
            />
          )}
          <LegalTerms
            className="order-summary-container__terms-and-conditions-check"
            name={ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.NAME}
            id={ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.ID}
            label={ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.LABEL}
            buttonText={ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.BUTTON_TEXT}
            control={control}
            rules={{
              required: ORDER_SUMMARY.TERMS_AND_CONDITIONS_CHECK.RULES.REQUIRED,
            }}
            legalTerms={legalTerms}
            cyData={`${ORDER_SUMMARY.ID}-legal-terms`}
          />
          {buttonCustomError && (
            <Text
              className="confirm__button--error"
              text={buttonCustomError}
              size={TEXT_SIZE.CAPTION2}
              color={TEXT_COLOR.RED}
              cyData={`${ORDER_SUMMARY.ID}__button-error`}
            />
          )}
          <Button
            onClick={() => {}}
            label="Confirmar pedido"
            className="confirm__button"
            type={BUTTON_TYPE.PRIMARY}
            width={BUTTON_WIDTH.FULL}
            buttonTypeHtml={BUTTON_TYPE_HTML.SUBMIT}
            operation={
              loadingButtonShoppingCart
                ? BUTTON_OPERATION.LOADING
                : BUTTON_OPERATION.NO
            }
            disabled={loadingButtonShoppingCart}
            taggingInfo={{
              componentName: 'button',
              componentVariation: 'all',
              componentContent: 'Confirmar pedido',
              componentProduct: '',
            }}
            cyData={`${ORDER_SUMMARY.ID}__button-confirm-order`}
          />
          {nextStepsText && (
            <Text
              text={nextStepsText}
              size={TEXT_SIZE.CAPTION2}
              color={TEXT_COLOR.GREY5}
              cyData={`${ORDER_SUMMARY.ID}__text`}
            />
          )}
        </div>
      )}
      <style jsx>
        {`
          .order-summary-container {
            margin-top: 10px;
            padding: 12px 16px 30px 16px;
            background-color: var(--color-gp--grey1);
            .order-summary-container__shopping-cart {
              :global(.order-summary-container__terms-and-conditions-check) {
                padding: 8px 0 16px 0;
              }
            }
            .order-summary-container__shopping-cart--opacity {
              opacity: 0.3;
            }
            :global(.order-summary__link) {
              margin-top: 16px;
              margin-bottom: 8px;
            }
            :global(.updateNote) {
              margin-top: 12px;
            }
            :global(.confirm__button) {
              margin-bottom: 8px;
            }
            :global(.confirm__button--error) {
              margin-bottom: 8px;
            }
          }
          @media screen and (min-width: 768px) {
            .order-summary-container {
              margin-top: 0px;
              padding: 0px;
              background-color: var(--color-gp--white);
            }
          }
        `}
      </style>
    </div>
  );
}
export default OrderSummary;
